var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slideshow"},[_c('ImagePadding',{attrs:{"source":_vm.currentImage,"disableLazy":true,"bg":_vm.bg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }